module.exports = __webpack_public_path__ + "static/media/account.a468201b.svg";